/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Trans, useTranslation } from "react-i18next";
import { Button } from "@material-ui/core";
import { useTheme } from "react-jss";
import { useParams } from "react-router-dom";
import useStyles from "./styles";
import CustomTypography from "../../CustomTypography";
import SvgClose from "../../Icons/Close";
import LocationContext from "../../../contexts/location";

/**
 * This function renders a component that handles the map attention page.
 * @returns The attention page.
 */
function Attention({ close }) {
  Attention.propTypes = {
    close: PropTypes.func.isRequired,
  };

  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const params = useParams();
  const { dataType } = useContext(LocationContext);

  return (
    <div className={classes.background}>
      <div
        className={classes.exit}
        role="button"
        onClick={() => close()}
        onKeyDown={() => {}}
        tabIndex={0}
      />
      <div className={classes.wrapper}>
        <div className={classes.container}>
          <div className={classes.header}>
            <CustomTypography variant="title">
              {t("dashboard.attention.title")}
            </CustomTypography>
            <Button className={classes.closeButton} onClick={() => close()}>
              <SvgClose className={classes.closeIcon} />
            </Button>
          </div>
          <div className={classes.content}>
            <div className={classes.text}>
              <CustomTypography
                style={{ marginBottom: 10, textAlign: "justify" }}
                variant="body"
                color={theme.text.gray}
              >
                {dataType === "glacier" &&
                (params.initiative === "ecuador" ||
                  params.initiative === "colombia" ||
                  params.initiative === "venezuela" ||
                  params.initiative === "peru") ? (
                  <Trans
                    i18nKey={`dashboard.attention.glacier.${params.initiative}`}
                    values={{
                      // email: "contato@mapbiomas.org",
                      link: window.location.origin,
                    }}
                    components={[<a />]}
                  />
                ) : (
                  <Trans
                    i18nKey={`dashboard.attention.water.${params.initiative}`}
                    values={{
                      // email: "contato@mapbiomas.org",
                      link: window.location.origin,
                    }}
                    components={[<a />]}
                  />
                )}
              </CustomTypography>
            </div>
            <Button
              className={classes.copyButton}
              variant="contained"
              disableElevation
              color="primary"
              onClick={() => close()}
            >
              <CustomTypography variant="contrast" color={theme.white}>
                {t("dashboard.attention.button")}
              </CustomTypography>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Attention;
